export default __webpack_public_path__ + "static/media/sms.25d538fc.gif";